
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IUnsubscribeOptionsForDropdown } from './unsubscribe-model';
import { UnsubscribeType } from '@shared/enums/UnsubscribeType';

@Injectable()
export class UnsubscribeService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${UnsubscribeService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/unsubscribeoptions';

    public getUnsubscribeOptionsForDropdown(unsubscribeType: UnsubscribeType): Observable<SuccessResponse<IUnsubscribeOptionsForDropdown> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IUnsubscribeOptionsForDropdown>>(UnsubscribeService.URL + '/dropdown' + '?unsubscribeOptionType=' + unsubscribeType).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
